'use client';
import { useState } from 'react';
import FormEmail from './FormEmail';
import FormInput from './FormInput';
import FormDate from './FormDate';
import FormTextarea from './FormTextarea';
import FormSelect from './FormSelect';
import FormRadio from './FormRadio';
import FormCheckbox from './FormCheckbox';
import FormInputAndCheckbox from './FormInputAndCheckbox';
import FormPrivacy from './comps/FormPrivacy';
import FormSubscribe from './comps/FormSubscribe';
import FormRecaptcha from './comps/FormRecaptcha';
import styles from './index.module.scss';
import { sendFormCommon } from './sendApis';
import getLocal from '@/app/utils/getLocal';
import { subscribe, sendSubscribeGet } from '@/service/vip';
import { message } from 'antd';
import gtm from '@/utils/gtm';

const pageSourceObj: any = {
    '/delta-pro-ultra-daily-use': 'daily use',
    '/calculators/delta-pro-ultra': 'daily use',
    '/delta-pro-ultra': 'backup',
    // '/smart-home-panel-2?withHeader=1': 'backup',
    '/smart-home-panel-2': 'shp2',
    '/whole-home-backup-power-solution': 'HBP',
    '/delta-pro-3-portable-power-station': 'DP3',
    '/delta-pro-portable-power-station': 'DP',
    '/delta-pro-ultra-x': 'DPU X',
};
export default function FormCommon({ id, source_page, data, callback }: any) {
    console.log('FormCommon', id, source_page, data, callback);
    const { theme, isPrivacy = true, isSubscribe = true, isRecaptcha = false, list = [] } = data;
    const { locale, pathname, query } = getLocal();
    const [listA, setListA] = useState(list);
    const [disabledSub, setDisabledSub] = useState(true); //置灰提交按钮
    const [privacyFlag, setPrivacyFlag] = useState(true); //是否已点击隐私协议
    const [subscribeFlag, setSubscribeFlag] = useState(true); //是否已点击订阅
    const [recaptchaVal, setRecaptchaVal] = useState(''); //人机验证的值
    const [isOpenCheck, setIsOpenCheck] = useState(false);
    const IS_COSTCO = query?.source === 'costco' && locale === 'us';
    const IS_SHOPIFY = query?.source === 'Shopify' && locale === 'ca';

    // 单项值变化回调
    const itemCallback = (item: any, index: number, value: any) => {
        const listA2 = JSON.parse(JSON.stringify(listA));
        const item2 = listA2[index] || {};
        if (item2.formType === 'inputAndCheckbox') {
            item2.data = item.data;
        } else {
            item2.itemVal = value;
        }

        setListA(listA2);
        // 是否置灰
        getVerifFromList(listA2);
    };
    // 是否置灰
    const getVerifFromList = (list: any, options?: any) => {
        let flag = true; //默认通过
        list.forEach((item: any) => {
            if (item.isRequire && !item.itemVal) {
                flag = false;
            }
        });

        // 配置了隐私协议,需要同意
        if (isPrivacy && !privacyFlag) {
            flag = false;
        }
        // 人机验证
        const options2 = options || {};
        const recaptchaVal2 = options2.recaptchaVal || recaptchaVal;
        if (isRecaptcha && !recaptchaVal2) {
            flag = false;
        }

        setDisabledSub(!flag); //设置是否置灰
        return flag;
    };
    // 从 list 中获取发送数据库的值
    const getParamsFromList = (list: any) => {
        const params: any = {};
        list.forEach((item: any) => {
            const itemKey = item.itemKey;
            if (item.formType === 'radio') {
                params[itemKey] = item.itemVal === 'Y' ? true : false;
            } else if (itemKey) {
                params[itemKey] = item.itemVal;
            }
        });
        // 人机验证
        if (isRecaptcha) {
            params.recaptchaResponse = recaptchaVal;
        }

        // 页面来源
        // if (source_page || pageSourceObj[pathname]) {
        //     params.source = pageSourceObj[pathname] || source_page;
        //     if (locale === 'us') {
        //         if (pathname === '/delta-pro-ultra') {
        //             params.source = 'backup';
        //         }
        //         if (pathname === '/smart-home-panel-2' && query?.withHeader !== '1') {
        //             params.source = 'shp2';
        //         }
        //     }
        // }
        if (pathname === '/delta-pro-ultra-x') {
            params.source = 'DPU X';
        } else if (pathname === '/smart-home-panel-2' && query?.withHeader === '1') {
            params.source = 'backup';
        } else if (pathname === '/dpu-home-solution') {
            params.source = 'dus';
        } else if (locale === 'ca' && (pathname === '/delta-pro-ultra' || pathname === '/calculators/delta-pro-ultra')) {
            if (pathname === '/delta-pro-ultra') {
                params.source = 'DPU';
            } else {
                params.source = 'calculators';
            }
            params.products = 'DELTA Pro Ultra';
        } else {
            params.source = pageSourceObj[pathname] || 'daily use';
        }
        if (IS_COSTCO) {
            params.source = 'costco';
        }
        if (IS_SHOPIFY) {
            params.source = 'Shopify';
        }

        return params;
    };
    // 从 list 中取出邮箱并订阅
    const getEmailFromList = (list: any) => {
        let email = '';
        list.forEach((item: any) => {
            if (item.formType === 'email') {
                email = item.itemVal;
            }
        });
        return email;
    };
    // 提交
    const submitHandle = async () => {
        const flag = getVerifFromList(listA);
        if (flag) {
            const fixLists = listA?.filter((l) => l.formType === 'inputAndCheckbox');
            fixLists.forEach((item: any) => {
                let r = '';
                item.data.forEach((item2: any, k: number) => {
                    r +=
                        (k > 0 && (Array?.isArray(item2.itemVal) ? item2.itemVal?.length > 0 : item2.itemVal) ? `;` : '') +
                        (Array?.isArray(item2.itemVal) ? item2.itemVal : item2.itemVal) +
                        (item2?.suffix && item2.itemVal ? item2?.suffix : '');
                });
                // 没有填第一个时会带有分号，得去掉
                if (r && r.substring(0, 1) === ';') {
                    r = r.substring(1);
                }
                item.itemVal = r;
            });
            const params = getParamsFromList(listA);
            const res = await sendFormCommon(params, locale);
            if (res.code === '0') {
                const email: string = getEmailFromList(listA);
                subscribe(email, locale, 'Web new product sub');
                sendSubscribeGet(email);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'pre_order_submit',
                    button_name: 'Submit',
                    status: 'success',
                });
                callback && callback();
                if (pathname === '/delta-pro-ultra-x') {
                    message.success('Submit Successfully!');
                    setDisabledSub(true);
                }
            } else {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'pre_order_submit',
                    button_name: 'Submit',
                    status: 'fail',
                });
                message.error(res.message);
                console.log('fail');
            }
        } else {
            setIsOpenCheck(true);
        }
    };
    // 隐私协议回调
    const privacyCallback = (flag: boolean) => {
        setPrivacyFlag(flag);
        getVerifFromList(listA);
    };
    // 邮箱订阅回调
    const subscribeCallback = (flag: boolean) => {
        setSubscribeFlag(flag);
    };
    // 人机验证回调
    const recaptchaCallback = (val: string) => {
        console.log('recaptchaCallback', val);
        setRecaptchaVal(val);
        getVerifFromList(listA, {
            recaptchaVal: val,
        });
    };
    return (
        <div className={`${styles.FormCommon} from-common-theme-${theme}`}>
            {listA.map((item: any, index: number) => {
                return (
                    <div
                        key={index}
                        className={`form-common-item${isOpenCheck && item.isRequire && !item.itemVal ? ' form-common-show-error' : ''} form-common-${
                            item.formWidth
                        }`}
                    >
                        {item.formType === 'email' && <FormEmail id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'input' && <FormInput id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'textarea' && <FormTextarea id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'select' && <FormSelect id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'radio' && <FormRadio id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'checkbox' && <FormCheckbox id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'date' && <FormDate id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'inputAndCheckbox' && <FormInputAndCheckbox id={id} data={item} index={index} callback={itemCallback} />}
                    </div>
                );
            })}
            {isPrivacy && <FormPrivacy callback={privacyCallback} />}
            {isSubscribe && <FormSubscribe callback={subscribeCallback} />}
            {isRecaptcha && <FormRecaptcha theme={theme} callback={recaptchaCallback} />}
            <div className="form-common-submit-box">
                <div className={`form-common-submit-btn ${disabledSub ? ' form-common-submit-disabled' : ''}`} onClick={submitHandle}>
                    Submit
                </div>
            </div>
        </div>
    );
}
